import { render, staticRenderFns } from "./pointsRank.vue?vue&type=template&id=71b6b371&scoped=true"
import script from "./pointsRank.vue?vue&type=script&lang=js"
export * from "./pointsRank.vue?vue&type=script&lang=js"
import style0 from "./pointsRank.vue?vue&type=style&index=0&id=71b6b371&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6b371",
  null
  
)

export default component.exports